import { com, kotlin, Nullable } from '@eidu/form'
import DraftFieldValue, { draftFieldValuesToFieldValues } from '../../domain/entity/DraftFieldValue'
import Link from '../../domain/entity/Link'
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId
import EntityToCreate = com.eidu.sharedlib.entity.api.entities.EntityToCreate
import KtMap = kotlin.collections.KtMap
import ExternalValueKey = com.eidu.sharedlib.entity.user.ExternalValueKey

const createEntityToCreate = (
  typeId: EntityTypeId,
  fieldValues: readonly DraftFieldValue[],
  links: readonly Link[],
  externalValues: ReadonlyMap<ExternalValueKey, Nullable<string>>
) =>
  new EntityToCreate(
    typeId,
    KtMap.fromJsMap(draftFieldValuesToFieldValues(fieldValues)),
    KtMap.fromJsMap(new Map(links.map((link) => [link.key, link.value]))),
    KtMap.fromJsMap(
      new Map(
        Array.from(externalValues.entries())
          .filter(([_, value]) => value !== null)
          .map(([key, value]) => [key, value as string])
      )
    )
  )

export default createEntityToCreate
